import React, { useState } from "react";

import { Card } from "../../../components/layout/Card";
import { ParagraphHeaderLarge } from "../../../components/typography/Paragraph";
import { SecondaryButton } from "../../../components/buttons/SecondaryButton";

import { ReadOnlyAnswerDisplay } from "./ReadOnlyAnswerDisplay";
import { CardHeader } from "./CardHeader";
import {
  QuestionSection,
  AnswersContainer,
  CardFooter,
} from "./DisputeComponents";
import { ResolutionsGetResponse } from "../../../../../api/src/users/answers/resolutions/route";
import { ChangeAnswerModal, MinimalDispute } from "./ChangeAnswerModal";

interface ResolutionCardProps {
  resolution: ResolutionsGetResponse[number];
  currentUserId: string;
  onResolutionChanged: () => void;
}

export const ResolutionCard: React.FC<ResolutionCardProps> = ({
  resolution,
  currentUserId,
  onResolutionChanged,
}) => {
  const [isChangeAnswerModalOpen, setIsChangeAnswerModalOpen] = useState(false);
  const isInitiatedByCurrentUser =
    resolution.initiatedByUserId === currentUserId;

  const dispute: MinimalDispute = {
    question: {
      id: resolution.question.id,
      parentQuestionGroupId: resolution.question.parentQuestionGroupId,
      parentQuestionnaireSectionId:
        resolution.question.parentQuestionnaireSectionId,
    },
    documentId: resolution.documentId ?? "",
  };

  return (
    <>
      <Card className="resolution-card">
        <CardHeader
          isResolved={true}
          title={resolution.question.parentQuestionGroup.title}
          groupIcon={resolution.question.parentQuestionGroup.groupIcon}
        />

        <QuestionSection>
          <ParagraphHeaderLarge>
            {resolution.question.title}
          </ParagraphHeaderLarge>
          <AnswersContainer>
            <ReadOnlyAnswerDisplay
              label={
                isInitiatedByCurrentUser
                  ? "Your Answer"
                  : "Your Partner's Answer"
              }
              answer={{
                valueTyped: resolution.previousTypedValue,
                answerQuestionOptions: resolution.previousOptionIds.map(
                  (optionId) => ({
                    questionOptionId: optionId,
                    answerId: resolution.answerId,
                  }),
                ),
              }}
              questionOptions={resolution.question.questionOptions.map(
                (option) => ({
                  ...option,
                  deletedAt: option.deletedAt
                    ? new Date(option.deletedAt)
                    : null,
                }),
              )}
              inputType={resolution.question.inputType}
            />
            <ReadOnlyAnswerDisplay
              label="Final Answer"
              answer={resolution.answer}
              questionOptions={resolution.question.questionOptions.map(
                (option) => ({
                  ...option,
                  deletedAt: option.deletedAt
                    ? new Date(option.deletedAt)
                    : null,
                }),
              )}
              isResolved={true}
              inputType={resolution.question.inputType}
            />
          </AnswersContainer>
        </QuestionSection>

        <CardFooter>
          <SecondaryButton
            onClick={() => {
              setIsChangeAnswerModalOpen(true);
            }}
          >
            Change Answer
          </SecondaryButton>
        </CardFooter>
      </Card>

      {isChangeAnswerModalOpen && (
        <ChangeAnswerModal
          onClose={() => {
            onResolutionChanged();
            setIsChangeAnswerModalOpen(false);
          }}
          dispute={dispute}
          title="Change Your Answer"
        />
      )}
    </>
  );
};
